var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"faq-header",attrs:{"id":_vm.headerId}},[_c('small',[_vm._v(_vm._s(_vm.subtitle))]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }